import { BudgetCategory, BudgetSubCategory } from "./types";

export interface BudgetCategoryReorderEntry {
  category_id: number;
  sort_order: number;
}

export interface BudgetSubCategoryReorderEntry {
  sub_category_id: number;
  sort_order: number;
}

export type BudgetStructureMoveDirection = -1 | 1;

export function moveBudgetCategory(
  categories: BudgetCategory[],
  categoryId: number,
  direction: BudgetStructureMoveDirection
): BudgetCategory[] | null {
  const index = categories.findIndex((category) => category.budget_category_id === categoryId);
  if (index === -1) return null;

  const targetIndex = index + direction;
  if (targetIndex < 0 || targetIndex >= categories.length) return null;

  const next = [...categories];
  const [moved] = next.splice(index, 1);
  next.splice(targetIndex, 0, moved);
  return next;
}

export function buildCategoryReorderPayload(
  categories: BudgetCategory[]
): BudgetCategoryReorderEntry[] {
  return categories.map((category, index) => ({
    category_id: category.budget_category_id,
    sort_order: index,
  }));
}

export function canMoveBudgetCategoryUp(categories: BudgetCategory[], categoryId: number): boolean {
  return categories.findIndex((category) => category.budget_category_id === categoryId) > 0;
}

export function canMoveBudgetCategoryDown(
  categories: BudgetCategory[],
  categoryId: number
): boolean {
  const index = categories.findIndex((category) => category.budget_category_id === categoryId);
  return index !== -1 && index < categories.length - 1;
}

export function moveBudgetSubCategory(
  subCategories: BudgetSubCategory[],
  subCategoryId: number,
  direction: BudgetStructureMoveDirection
): BudgetSubCategory[] | null {
  const index = subCategories.findIndex(
    (subCategory) => subCategory.budget_sub_category_id === subCategoryId
  );
  if (index === -1) return null;

  const targetIndex = index + direction;
  if (targetIndex < 0 || targetIndex >= subCategories.length) return null;

  const next = [...subCategories];
  const [moved] = next.splice(index, 1);
  next.splice(targetIndex, 0, moved);
  return next;
}

export function buildSubCategoryReorderPayload(
  subCategories: BudgetSubCategory[]
): BudgetSubCategoryReorderEntry[] {
  return subCategories.map((subCategory, index) => ({
    sub_category_id: subCategory.budget_sub_category_id,
    sort_order: index,
  }));
}

export function canMoveBudgetSubCategoryUp(
  subCategories: BudgetSubCategory[],
  subCategoryId: number
): boolean {
  return (
    subCategories.findIndex((subCategory) => subCategory.budget_sub_category_id === subCategoryId) >
    0
  );
}

export function canMoveBudgetSubCategoryDown(
  subCategories: BudgetSubCategory[],
  subCategoryId: number
): boolean {
  const index = subCategories.findIndex(
    (subCategory) => subCategory.budget_sub_category_id === subCategoryId
  );
  return index !== -1 && index < subCategories.length - 1;
}
